import type { ReactNode } from 'react'

interface HeaderProps { title: string; subtitle?: string; actions?: ReactNode }

export function Header({ title, subtitle, actions }: HeaderProps) {
  return <header className="pc-header">
    <div className="min-w-0"><h1>{title}</h1>{subtitle && <p>{subtitle}</p>}</div>
    {actions && <div className="flex items-center flex-wrap gap-2">{actions}</div>}
  </header>
}
